import React from 'react';
import { useHistory } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { makeStyles } from '@material-ui/core/styles';
import { QueueSelectedProvider } from '../../context/QueuesSelected/QueuesSelectedContext';
import Ticket from '../Ticket';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    height: '85vh',
  },
  content: {
    padding: 0,
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
  },
}));

const TicketModal = ({ open, onClose, ticketUuid }) => {
  const classes = useStyles();
  const history = useHistory();

  const handleGoToTicket = () => {
    onClose();
    history.push(`/tickets/${ticketUuid}`);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='md'
      fullWidth
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogContent className={classes.content}>
        {ticketUuid && (
          <QueueSelectedProvider>
            <Ticket ticketId={ticketUuid} isModal />
          </QueueSelectedProvider>
        )}
      </DialogContent>
      <DialogActions>
        <IconButton onClick={onClose} size='small' title='Fechar'>
          <CloseIcon />
        </IconButton>
        <Button
          onClick={handleGoToTicket}
          color='primary'
          variant='contained'
          startIcon={<OpenInNewIcon />}
        >
          Ir para conversa
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketModal;
